<template>
  <div class="row m-0">
    <div class="col-12">
      <h1 class="title font-weight-bold text-uppercase">
        Pagamento cotação {{ this.cotacao[0].id }}
      </h1>
      <hr class="linha-amarela" />
    </div>
    <div class="col-12">
      <div class="card-cotacao">
        <div class="cc-sub-title">Seus items:</div>
        <div class="table-responsive">
          <table class="table table-pedidos">
            <thead>
              <tr class="tr fs-12">
                <th class="th">Item</th>
                <th class="th">Nome</th>
                <th class="th">Marca</th>
                <th class="th">Medida</th>
                <th class="th">Quantidade</th>
                <th class="th">Undidade</th>
                <th class="th">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="tr fs-14"
                v-for="(produto, index) in cotacao[0].produtos"
                :key="index"
              >
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  {{ index + 1 }}
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  <div
                    v-if="produto.disponivel == true && produto.disponivel == 1"
                  >
                    {{ produto.produto_nome }}
                  </div>
                  <div v-else>Não tem {{ produto.produto_nome }}</div>
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  <div v-if="produto.marca_nome">
                    {{ produto.marca_nome }}
                  </div>
                  <div v-else>Sem Marca</div>
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  <div v-if="produto.tipo_medida_nome">
                    {{ produto.tipo_medida_nome }}
                  </div>
                  <div v-else>Sem Medida</div>
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  <span class="ml-4">{{ produto.qtd_quantidade }}</span>
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  {{ produto.preco_unidades }}
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                >
                  {{ produto.preco_total }}
                </td>
                <td
                  v-bind:class="
                    'td' +
                    [
                      produto.disponivel == true &&
                      produto.disponivel == 1 &&
                      produto.rejeitar !== true &&
                      produto.rejeitar !== 1
                        ? ''
                        : ' red-font',
                    ]
                  "
                  v-if="produto.disponivel == true"
                ></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mb-4">
          <span>Valor total: {{ cotacao[0].cot_valor_total }}</span>
        </div>

        <div class="container">
          <div class="mb-4 text-center">
            <h4>Meio de pagamento</h4>
            <p>Escolha seu método de pagamento</p>
          </div>

          <div class="row">
            <div
              v-if="cardValue > 0"
              class="col cotacao-div"
              style="padding: 0 5px"
            >
              <div
                :class="activeCredit ? 'c-click' : ''"
                @click="toggleButton('credit_card')"
              >
                <div class="cardPayment">
                  <i class="far fa-credit-card iconPayment"></i>
                  <span> Crédito </span><br>
                </div>
              </div>
            </div>

            <div
              v-if="pixValue > 0"
              class="col cotacao-div"
              style="padding: 0 5px"
            >
              <div
                v-bind:class="activePix ? 'c-click' : ''"
                v-on:click="toggleButton('pix')"
              >
                <div class="cardPayment">
                  <i class="fas fa-dollar-sign mr-2 iconPayment"></i>
                  <span>Pix</span>
                </div>
              </div>
            </div>

            <div
              v-if="ticketValue > 0"
              class="col cotacao-div"
              style="padding: 0 5px"
            >
              <div
                :class="activeTicket ? 'c-click' : ''"
                @click="toggleButton('all')"
              >
                <div class="cardPayment">
                  <i class="fas fa-barcode mr-2 iconPayment"></i>
                  <span>Boletos</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cc-content mt-5">
          <div v-if="activeCredit">
            <TableCredit
              :valueCard="cardValue"
              :installments="installments"
              :installmentsValue="installmentsValue"
            />
          </div>

          <div v-if="activePix">
            <PixClient :valuePix="pixValue" />
          </div>

          <div v-if="activeTicket">
            <TicketClient :valueTicket="ticketValue" />
          </div>
        </div>

        <div class="card mb-4">
          <div class="card-body">
            <h4 class="text-center">Meus dados</h4>
            <p class="text-center mb-4">
              Verifica abaixo se os dados estão corretos, caso não esteja favor
              corrigir
            </p>
            <div class="form-group row g-3">
              <div class="col-md-6">
                <label for="name">Nome completo</label>
                <input
                  v-model="name"
                  class="form-control mb-3"
                  id="name"
                  placeholder="Digite seu nome completo"
                />
              </div>
              <div class="col-md-6">
                <label for="email">E-mail</label>
                <input
                  v-model="email"
                  class="form-control mb-3"
                  id="email"
                  placeholder="email@exemplo.com"
                />
              </div>
              <div class="col-md-6">
                <label for="cpf">CPF</label>
                <input
                  type="text"
                  v-model="cpf"
                  class="form-control mb-3"
                  id="cpf"
                  placeholder="Digite seu cpf"
                  v-mask="'###.###.###-##'"
                />
              </div>
              <div class="col-md-6">
                <label for="phone">Telefone</label>
                <input
                  type="text"
                  v-model="phone"
                  class="form-control mb-3"
                  id="phone"
                  placeholder="Digite seu telefone"
                  v-mask="'(##) #####-####'"
                />
              </div>
              <div class="col-md-6">
                <label for="street">CEP</label>
                <input
                  v-model="zipcode"
                  v-mask="'#####-###'"
                  class="form-control mb-3"
                  id="zipcode"
                  placeholder="Digite seu cep"
                />
              </div>
              <div class="col-md-6">
                <label for="street">Endereço</label>
                <input
                  v-model="street"
                  class="form-control mb-3"
                  id="street"
                  placeholder="Digite o endereço"
                />
              </div>
              <div class="col-md-6">
                <label for="number">Número</label>
                <input
                  v-model="number"
                  class="form-control mb-3"
                  id="number"
                  placeholder="Digite o numero da casa"
                />
              </div>
              <div class="col-md-6">
                <label for="district">Bairro</label>
                <input
                  v-model="district"
                  class="form-control mb-3"
                  id="district"
                  placeholder="Digite o bairro"
                />
              </div>
              <div class="col-md-6">
                <label for="Cidade">Cidade</label>
                <input
                  v-model="city"
                  class="form-control mb-3"
                  id="Cidade"
                  placeholder="Digite a cidade"
                />
              </div>
              <div class="col-md-6">
                <label for="street">Estado</label>
                <input
                  v-model="stateLocal"
                  class="form-control mb-3"
                  id="Estado"
                  placeholder="Digite o estado"
                />
              </div>

              <div class="col-12">
                <b-button @click="submitInvoice()" class="mt-3 btn-success"
                  >Ir para o pagamento</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import makeToast from '../../mixins/makeToast';
import TableCredit from '../cliente/TableCredit.vue';
import PixClient from '../cliente/PixClient.vue';
import TicketClient from '../cliente/TicketClient.vue';

export default {
  name: 'cotacao-pagamento',
  components: {
    TableCredit,
    PixClient,
    TicketClient,
  },
  data() {
    return {
      name: null,
      email: null,
      cpf: null,
      phone: null,
      street: null,
      number: null,
      district: null,
      city: null,
      cep: null,
      stateLocal: null,
      zipcode: null,
      payment: '',
      activeCredit: false,
      activePix: false,
      activeTicket: false,
      cardValue: 0,
      installments: 0,
      installmentsValue: 0,
      money: 0,
      discount: '',
      pixValue: 0,
      ticketValue: 0,
      quote: [],
      discountCents: '',
      discountPix: '',
      discountCard: '',
      discountTicket: '',
      loading: false,
      cepConsult: {
        consulted: false,
        isValidAddress: true,
        isValidNeighborhood: true,
      },
    };
  },
  mixins: [makeToast],
  computed: {
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      invoices: (state) => state.invoices,
    }),
  },
  watch: {
    zipcode: function () {
      this.consultCep();
    },
  },
  created() {
    this.get();
  },
  mounted() {
    this.loadQuote();
    this.viewDataUser();
  },
  methods: {
    unsMaskValor(valor) {
      return parseInt(String(valor).replace(/[\D]+/g, ''));
    },
    viewDataUser() {
      this.email = this.dadosUsuario.email;
      this.name = this.dadosUsuario.nome_usuario;
      this.cpf = this.dadosUsuario.cpf;
      this.phone = this.dadosUsuario.informacoes.celular;
      this.zipcode = this.dadosUsuario.informacoes.cep;
      this.street = this.dadosUsuario.informacoes.endereco;
      this.number = this.dadosUsuario.informacoes.numero;
      this.district = this.dadosUsuario.informacoes.bairro;
      this.city = this.dadosUsuario.informacoes.cidade.nome;
      this.stateLocal = this.dadosUsuario.informacoes.estado.nome;
    },
    consultCep() {
      if (!this.loading && this.zipcode.length === 9) {
        this.loading = true;
        this.$store.dispatch('startLoader');
        let cep = this.unsMaskValor(this.zipcode).toString();
        this.$store
          .dispatch('user/consultCep', cep)
          .then(async (response) => {
            this.validateCepResults(response.data);
          })
          .catch((error) => {
            this.makeToast('Oopss!', error.response.data.message, 'danger');
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch('endLoader');
          });
      }
      if (this.cep && this.cep.length === 0) {
        this.cepConsult.consulted = false;
        this.street = null;
        this.district = null;
        this.city = null;
      }
    },
    validateCepResults(result) {
      this.cepConsult.consulted = true;
      this.cepConsult.isValidAddress = !!result.logradouro;
      this.cepConsult.isValidNeighborhood = !!result.bairro;
      this.street = result.logradouro || null;
      this.district = result.bairro || null;
      this.city = result.localidade || null;
      this.stateLocal = result.uf || null;
    },
    submitInvoice() {
      const cotacao = this.cotacao[0].produtos;
      const items = [];
      for (let i = 0; i < cotacao.length; i++) {
        const data = {
          description: cotacao[i].produto_nome,
          quantity: cotacao[i].qtd_quantidade,
          price_cents: cotacao[i].preco_unidades_sem_mascara,
        };
        items.push(data);
      }
      this.selectPayment();
      const data = {
        id: this.cotacao[0].id,
        idCotacao: this.cotacao[0].cot_cotacao_id,
        name: this.name,
        option_payment: this.payment,
        email: this.email,
        cpf: this.unsMaskValor(this.cpf).toString(),
        phone: this.unsMaskValor(this.phone).toString(),
        street: this.street,
        number: this.number,
        district: this.district,
        state: this.stateLocal,
        city: this.city,
        zipcode: this.unsMaskValor(this.zipcode).toString(),
        item: items,
        shop_id: this.cotacao[0].cot_usuario_respondeu_id,
        discount_cents: this.discountCents,
        user_id: this.cotacao[0].cot_usuario_receb_resp_id,
      };
      if (this.payment != '') {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('postCheckout', data)
          .then(() => {
            this.makeToast('Opa!', 'Fatura criada com sucesso', 'success');

            if (data.option_payment == 'all') {
              this.$router.push({
                name: 'profissional-cotacao-pagamento-bb',
                params: {
                  id: this.cotacao[0].cot_cotacao_id,
                  id_shop: this.cotacao[0].cot_usuario_respondeu_id,
                },
              });
            } else if (data.option_payment == 'pix') {
              this.$router.push({
                name: 'profissional-cotacao-pagamento-pix',
                params: {
                  id: this.cotacao[0].cot_cotacao_id,
                  id_shop: this.cotacao[0].cot_usuario_respondeu_id,
                },
              });
            } else if (data.option_payment == 'credit_card') {
              this.$router.push({
                name: 'profissional-cotacao-pagamento-cc',
                params: {
                  id: this.cotacao[0].cot_cotacao_id,
                  id_shop: this.cotacao[0].cot_usuario_respondeu_id,
                  cot_id: this.cotacao[0].id,
                },
              });
            }
          })
          .catch((error) => {
            this.makeToast(
              'Oopss!',
              'Favor verificar os campos se estão preenchidos corretamente',
              'danger'
            );
          })
          .finally(() => this.$store.dispatch('endLoader'));
      }
    },
    loadQuote() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('emptyCotacao').then(() => {
        this.$store
          .dispatch('showCotacaoRespondida', this.$route.params.id)
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast(
              'Oops!',
              'Não foi possível carregar os orçamento! Tente novamente em 5 minutos!',
              'danger'
            );
          })
          .finally(() => this.$store.dispatch('endLoader'));
      });
    },
    toggleButton(value) {
      if (value == 'credit_card') {
        this.activeCredit = !this.activeCredit;
        this.activePix = false;
        this.activeTicket = false;
        this.discountCents =
          this.quote[0].cot_valor_total_sem_mascara * this.discountCard;
        this.discountCents = (this.discountCents / 100)
          .toFixed(2)
          .replace('.', '');
      }
      if (value == 'pix') {
        this.activePix = !this.activePix;
        this.activeCredit = false;
        this.activeTicket = false;
        this.discountCents =
          this.quote[0].cot_valor_total_sem_mascara * this.discountPix;
        this.discountCents = (this.discountCents / 100)
          .toFixed(2)
          .replace('.', '');
      }
      if (value == 'all') {
        this.activeTicket = !this.activeTicket;
        this.activePix = false;
        this.activeCredit = false;
        this.discountCents =
          this.quote[0].cot_valor_total_sem_mascara * this.discountTicket;
        this.discountCents = (this.discountCents / 100)
          .toFixed(2)
          .replace('.', '');
      }
    },
    selectPayment() {
      if (this.activePix) {
        this.payment = 'pix';
      } else if (this.activeTicket) {
        this.payment = 'all';
      } else if (this.activeCredit) {
        this.payment = 'credit_card';
      } else {
        this.makeToast(
          'Oops!',
          'Favor selecionar uma forma de pagamento!',
          'danger'
        );
      }
    },
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    get() {
      this.$store
        .dispatch('showValueQuote', this.cotacao[0].id)
        .then((response) => {
          this.quote = response.data.data;
          this.calcValues();
        });
    },
    calcValues() {
      let payment = this.quote;
      let valor = this.quote[0].cot_valor_total_sem_mascara;
      let quoteValue = valor / 100;
      let boleto;
      let pix;
      let cartao;

      //vendo as formas de pagamento
      payment[0].formas_pagamentos.forEach((formaPagamento) => {
        if (formaPagamento.forma_de_pagamento == 'P') {
          pix = formaPagamento.forma_de_pagamento;
          this.discountPix = formaPagamento.desconto / 100;
        }
        if (formaPagamento.forma_de_pagamento == 'B') {
          boleto = formaPagamento.forma_de_pagamento;
          this.discountTicket = formaPagamento.desconto / 100;
        }
        if (formaPagamento.forma_de_pagamento == 'C') {
          cartao = formaPagamento.forma_de_pagamento;
          this.discountCard = formaPagamento.desconto / 100;
          this.installments = formaPagamento.parcela;
        }
      });

      // aplicando os descontos
      if (pix) {
        this.pixValue = quoteValue - this.discountPix * 100;
      }
      if (boleto) {
        this.ticketValue = quoteValue - this.discountTicket * 100;
      }
      if (cartao) {
        this.cardValue = quoteValue - this.discountCard * 100;
        this.installmentsValue = this.cardValue / this.installments;
      }
    },
  },
};
</script>

<style>
.cardPayment {
  border: 1px solid #dfdfdf;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}
.iconPayment {
  margin-top: 5px;
  margin-right: 7px;
}
</style>
